<template>
    <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
      <div class="delete-modal">
        <div class="flex justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 47 47" fill="none">
                <g clip-path="url(#clip0_2930_39984)">
                <path d="M46.3001 23.1501C46.3001 35.9356 35.9356 46.3001 23.1501 46.3001C10.3646 46.3001 0 35.9356 0 23.1501C0 10.3646 10.3646 0 23.1501 0C35.9356 0 46.3001 10.3646 46.3001 23.1501Z" fill="#09B78A" fill-opacity="0.1"/>
                <path d="M20.2775 26.2659L16.3785 22.3993L15 23.7663L20.2775 29L31 18.367L29.6215 17L20.2775 26.2659Z" fill="#09B78A"/>
                </g>
                <defs>
                <clipPath id="clip0_2930_39984">
                <rect width="46.3" height="46.3" fill="white"/>
                </clipPath>
                </defs>
                </svg>
        </div>
  
        <div class="my-6">
          <div>
            <div class="text-primary-green">Your booking is confirmed.</div>
            You are required to drop off your shipment at <b v-html="endRoute"></b></div>
        </div>
          <div>
            <base-button @click="closeModal()" text="Close" />
          </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
        required: true,
        default: false,
      },
      endRoute: {type: String}
    },
    data(){
      return {
        showDeclineReasonModal: false
      }
    },

    methods: {
      closeModal() {
        this.showDeclineReasonModal = true
        this.$emit("close-modal");
        this.$router.push('/active-bookings')
        this.$store.dispatch('saveLatestNewBookinTabNum', 1)
        this.$store.dispatch('saveResetNewBookingState')
      },
    }
  };
  </script>
  
  <style scoped>
  .delete-modal {
    text-align: center;
  }
  </style>
  